import { format } from 'date-fns'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { AbsenceDay } from '../../types/absence-day'
import { getPayApprovalHoursDisplayValue, getUnpaidHoursDisplayValue } from '../../utils/absence-utils'
import palette from '../../theme/palette'

export const createManAuthAbsenceDetailColumns = (): GridColDef<AbsenceDay>[] => [
  {
    field: 'date',
    headerName: 'Date',
    width: 120,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => (
      <span>{value ? format(new Date(value), 'd MMM yyyy') : 'N/A'}</span>
    ),
  },
  {
    field: 'hoursLost',
    headerName: 'Absence Hours',
    flex: 1,
    minWidth: 140,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => {
      const numValue = value ?? 0
      if (numValue === 0) {
        return <span style={{ color: palette.type.multipleRequests.color }}>0.00</span>
      }
      return (
        <span style={{ color: palette.type.absence.color }}>
          {`-${Math.abs(numValue).toFixed(2)}`}
        </span>
      )
    },
  },
  {
    field: 'payApproval',
    headerName: 'Discretionary Pay',
    flex: 1,
    minWidth: 140,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: GridRenderCellParams<AbsenceDay>) => (
      <span>
        {getPayApprovalHoursDisplayValue(params.row.payApproval ?? 0, params.row.manAuthRequestStatus ?? '')}
      </span>
    ),
  },
  {
    field: 'unpaid',
    headerName: 'Unpaid',
    flex: 1,
    minWidth: 140,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: GridRenderCellParams<AbsenceDay>) => (
      <span>
        {getUnpaidHoursDisplayValue(
          params.row.unpaid ?? 0,
          params.row.payApproval ?? 0,
          params.row.manAuthRequestStatus ?? ''
        )}
      </span>
    ),
  },
]
